import { createReducer } from 'redux-act';
import axios from 'axios';

import { handleError } from 'magic/handlers';
import actionsFactory from 'magic/actionsFactory';
import { isFunction } from 'utils/lodash';
import { DISCIPLINES } from 'constants/disciplines';

const DEFAULT_DISCIPLINE = { id: DISCIPLINES.FOOTBALL, name: 'Футбол', sysName: 'Football' };

const createAction = actionsFactory('profile/transfersHistory/');
const initialState = {
  form: {
    action: null,
    club: null,
    initdate: null,
    status: false,
  },
  items: [],
  transfersHistoryInfo: null,
  transfersHistoryInfoLoading: true,
  selectedDiscipline: DEFAULT_DISCIPLINE,
  editingRowIndex: undefined,
  transfersHistoryDataIsLoading: false,
};

// Очистка всего стора
export const clearData = createAction('clearData');
export const fillTransfersHistory = createAction('fillTransfersHistory');

// История переходов
export const fillTransfersHistoryData = createAction('fillTransfersHistoryData');
export const setTransfersHistoryDataByKey = createAction('setTransfersHistoryDataByKey');
export const clearTransfersHistoryData = createAction('clearTransfersHistoryData');
const setTransfersHistoryInfoLoading = createAction('transfersHistoryInfoLoading');

const _setTransfersHistoryInfo = createAction('setTransfersHistoryInfo');
export const purgeTransfersHistoryInfo = createAction('purgeTransfersHistoryInfo');
export const setSelectedDiscipline = createAction('setSelectedDiscipline');
export const setEditingRowIndex = createAction('setEditingRowIndex');
export const setTransfersHistoryDataIsLoading = createAction('setTransfersHistoryDataIsLoading');

export const getTransfersHistoryInfo = ({ eventId, onError }) => async (dispatch) => {
  dispatch(setTransfersHistoryInfoLoading(true));
  try {
    const {
      data: { data },
    } = await axios.get(`/api/rest/audit/transfer/view/${eventId}`);
    dispatch(_setTransfersHistoryInfo(data));
  } catch (error) {
    handleError(error);
    if (isFunction(onError)) {
      onError(error);
    }
  } finally {
    dispatch(setTransfersHistoryInfoLoading(false));
  }
};

const reducer = createReducer(
  {
    [_setTransfersHistoryInfo]: (state, payload) => ({
      ...state,
      transfersHistoryInfo: payload,
    }),
    [clearData]: () => initialState,
    [clearTransfersHistoryData]: (state) => ({
      ...state,
      form: {
        action: null,
        club: null,
        initdate: null,
        status: false,
      },
    }),
    [fillTransfersHistory]: (state, payload) => ({
      ...state,
      items: payload,
    }),
    [fillTransfersHistoryData]: (state, item) => ({
      ...state,
      form: item,
    }),
    [purgeTransfersHistoryInfo]: (state) => ({
      ...state,
      transfersHistoryInfo: initialState.transfersHistoryInfo,
    }),
    [setTransfersHistoryDataByKey]: (state, { key, value }) => ({
      ...state,
      form: {
        ...state.form,
        [key]: value,
      },
    }),
    [setTransfersHistoryInfoLoading]: (state, payload) => ({
      ...state,
      transfersHistoryInfoLoading: payload,
    }),
    [setSelectedDiscipline]: (state, payload) => ({
      ...state,
      selectedDiscipline: payload,
    }),
    [setEditingRowIndex]: (state, payload) => ({
      ...state,
      editingRowIndex: payload,
    }),
    [setTransfersHistoryDataIsLoading]: (state, payload) => ({
      ...state,
      transfersHistoryDataIsLoading: payload,
    }),
  },
  initialState,
);

export default reducer;
